export var SelectorRowDecorativeElementTypeEnum;
(function (SelectorRowDecorativeElementTypeEnum) {
    SelectorRowDecorativeElementTypeEnum["ICON"] = "ICON";
    SelectorRowDecorativeElementTypeEnum["ICON_HIGHLIGHTED"] = "ICON_HIGHLIGHTED";
    SelectorRowDecorativeElementTypeEnum["ILLUSTRATION"] = "ILLUSTRATION";
    SelectorRowDecorativeElementTypeEnum["AVATAR_PROFILE"] = "AVATAR_PROFILE";
})(SelectorRowDecorativeElementTypeEnum || (SelectorRowDecorativeElementTypeEnum = {}));
//# sourceMappingURL=decorativeElement.js.map